import { render } from "./BuyerNegotiationPage.vue?vue&type=template&id=b0a3397a&scoped=true"
import script from "./BuyerNegotiationPage.vue?vue&type=script&lang=js"
export * from "./BuyerNegotiationPage.vue?vue&type=script&lang=js"

import "./BuyerNegotiationPage.vue?vue&type=style&index=0&id=b0a3397a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a3397a"]])

export default __exports__